module.exports = __webpack_public_path__ + "img/preview-6.34cc45ec.png";